// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCoveoState } from "@eisinc/App/CoveoConnector/Store/Reducers";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";

export const CoveoStoreAnalyticsObject: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState() as xCoveoState;

    if (state.xCoveo.trackCoveo && props.apiParameter.query) {
        /**
         * productAnalyticsObject is a custom properties returned from BE
         * it has search related data from Coveo
         * used (props.apiResult as any) because BE returns custom fields on result,
         * and it doesn't exist on OOTB result model
         */
        const analyticsObject = (props.apiResult as any)?.productAnalyticsObject;

        props?.apiResult?.products?.forEach(product => {
            const { styleParentId, id, erpNumber, title, url } = product;
            const targetId = styleParentId || id;
        
            const [matchingItem] = analyticsObject?.items?.filter((elem: any) => elem.id === targetId) || [];
        
            if (matchingItem) {
                matchingItem['erpNumber'] = erpNumber;
                matchingItem['title'] = title;
                matchingItem['url'] = url;
            }
        });
        
        props.dispatch({
            type: "xCoveo/storeSearchAnalyticsObject",
            analyticsObject,
            query: props.apiParameter.query,
            searchHub: "search",
        } as any);
    }
};

addToEndOfChain(chain, CoveoStoreAnalyticsObject);
